import { render, staticRenderFns } from "./RefundApprove.vue?vue&type=template&id=55ca03b9&scoped=true&"
import script from "./RefundApprove.vue?vue&type=script&lang=js&"
export * from "./RefundApprove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ca03b9",
  null
  
)

export default component.exports